import React,{ useState, useEffect, useRef } from 'react';

import Star from './Star/Star';
import BigCard from './BigCard/BigCard';
import Reviews from './Reviews/Reviews';
import Questions from './Questions/Questions';
import ImgTimeLine from './ImgTimeLine/ImgTimeLine';
import CarouselDom from './CarouselDom/CarouselDom';
import Community from './Community/Community'
import AutoScrolling from './AutoScrolling/AutoScrolling';
import AutoSwitching from './AutoSwitching/AutoSwitching';
import ProductDescription from './ProductDescription/ProductDescription';
import CardDom from './CardDom/CardDom';
import Menu from './Menu/Menu';
import ChartBarDom from './ChartBarDom/ChartBarDom'
import ChartLineDom from './ChartLineDom/ChartLineDom';
import PhotoWall from './PhotoWall/PhotoWall';
import BaseBanner from './BaseBanner/BaseBanner'
import Contrast from './Contrast/Contrast';


const ModuleLoader = ({moduleType, moduleData}) =>{
  console.log('moduleData', moduleData)

  let moduleConfig = [
    {dictLabel:"评论",dictValue:"reviews",component: <Reviews reviewsData={{}} isName={true}/>},
    {dictLabel:"柱状图",dictValue:"bar",component: <ChartBarDom />},
    {dictLabel:"表格", dictValue:"table", component: <Contrast type={'quality'}/>},
    {dictLabel:"表格(带背景图)",dictValue:"table_bg",component: <Contrast type={'nutrition'}/>},

    {dictLabel:"社区",dictValue:"community",component: <Community communityData={moduleData}/>},
    {dictLabel:"自动切换卡片",dictValue:"auto_switching",component: <AutoSwitching AutoSwitchingData={moduleData}/>},
    
    {dictLabel:"推荐商品",dictValue:"recommend_goods",component: <CardDom type={'bigGoods'} content={moduleData} btnConfig={{link:`/shopDetail/${moduleData && moduleData.id}`}}/>},

    {dictLabel:"轮播 - 商品",dictValue:"carousel_goods",component: <CarouselDom CarouselData={moduleData}/>},
    {dictLabel:"轮播 - 关于",dictValue:"carousel_article",component: <CarouselDom CarouselData={moduleData}/>},

    {dictLabel:"图片在左侧的卡片",dictValue:"card_img_left",component: <BigCard bigCardData={{type: 'imgCard',textPosition: 'left',textAlignItem: 'center', ...moduleData}}/>},
    {dictLabel:"图片在右侧的卡片",dictValue:"card_img_right",component: <BigCard bigCardData={{type: 'imgCard',textPosition: 'right',textAlignItem: 'center', ...moduleData}}/>},
    {dictLabel:"图片在左侧，右侧内容含小卡片",dictValue:"card_img_left_icon",component: <BigCard bigCardData={{type: 'imgCard',textPosition: 'left',textAlignItem: 'top', ...moduleData}}/>},
    {dictLabel:"图片在右侧，左侧内容含小卡片",dictValue:"card_img_right_icon",component: <BigCard bigCardData={{type: 'imgCard',textPosition: 'right',textAlignItem: 'top', ...moduleData}}/>},
    {dictLabel:"带背景图片的卡片，内容在左侧",dictValue:"card_bg_leftContent",component: <BigCard bigCardData={{type: 'bgCard', textPosition: 'left', ...moduleData}}/>},
    {dictLabel:"带背景图片的卡片，内容在右侧",dictValue:"card_bg_rightContent",component: <BigCard bigCardData={{type: 'bgCard', textPosition: 'right', ...moduleData}}/>},
    {dictLabel:"含有2张图片模块，呈两列分布",dictValue:"model_dbImg",component: <BigCard bigCardData={{type: 'dbCard', ...moduleData}}/>},
    {dictLabel:"含有两张图片的模块，左侧展示内容",dictValue:"model_dbImg_leftContent",component: <BigCard bigCardData={{type: 'goodCard', ...moduleData}}/>},
    
    {dictLabel:"照片墙",dictValue:"photo_wall",component: <PhotoWall PhotoWallData={{drawer: false, ...moduleData}}/>},
    {dictLabel:"照片墙，带抽屉",dictValue:"photo_wall_drawer",component: <PhotoWall PhotoWallData={{drawer: true, ...moduleData}}/>},
    
    {dictLabel:"产品亮点",dictValue:"model_description",component: <ProductDescription productDescriptionData={moduleData}/>},
    {dictLabel:"Q_A",dictValue:"Q_A",component: <Questions questionsData={moduleData}/>},
    {dictLabel:"图片时间轴",dictValue:"img_timeLine",component: <ImgTimeLine ImgTimeLineData={moduleData}/>},
  ]

  return (
    <div style={{width: '100%'}}>
      {moduleConfig.find(e=> e.dictValue === moduleType).component}
    </div>
  )
}
export default ModuleLoader